<template class="background-template">
    <div> <!-- Contenedor principal -->
        <div>
            <div class="login-keyboard">
                <div class="waiter-selector" v-if="waiter_selector">
                    
                    <div class="waiter-pin-section">
                        <div class="logo-container">
                            <img src="https://development.vinapp.co/logo2.jpg" alt="Logo" class="popup-logo">
                        </div>
                        <input 
                            type="password" 
                            id="waiterPin" 
                            class="waiter-pin-input" 
                            placeholder="Ingrese su PIN" 
                            maxlength="4"
                            v-model="pinInput"
                            @keydown.enter="submitPin"
                        >
                        <div class="pin-keypad">
                            <button class="pin-key" data-key="1" @click="appendNumber('1')">1</button>
                            <button class="pin-key" data-key="2" @click="appendNumber('2')">2</button>
                            <button class="pin-key" data-key="3" @click="appendNumber('3')">3</button>
                            <button class="pin-key" data-key="4" @click="appendNumber('4')">4</button>
                            <button class="pin-key" data-key="5" @click="appendNumber('5')">5</button>
                            <button class="pin-key" data-key="6" @click="appendNumber('6')">6</button>
                            <button class="pin-key" data-key="7" @click="appendNumber('7')">7</button>
                            <button class="pin-key" data-key="8" @click="appendNumber('8')">8</button>
                            <button class="pin-key" data-key="9" @click="appendNumber('9')">9</button>
                            <button class="pin-key pin-clear" @click="clearInput">C</button>
                            <button class="pin-key" data-key="0" @click="appendNumber('0')">0</button>
                            <button class="pin-key pin-enter" @click="submitPin">↵</button>
                        </div>
                        <small v-show="errorLogin" style="color:red;font-weight: 900!important;">{{errorLogin}}</small>
                    </div>
                </div>
            </div>
        </div>
        <TableWaiters v-if="popupActivoModeMesero" :onFinish="finishTableWaiters" :idCompany="Number(id_company)" :idPoint="id_point_waiter"></TableWaiters>
    </div>
    
</template>



<script>
    import axios from '@/config/axios';
    import TableWaiters from './TableWaiters.vue';
    export default {
        name: "LoginKeyboard",
        props: ["onFinish"],
        components: {
          TableWaiters
        },
        data() {
            return {
                waiter_selector: true,
                popupActivoModeMesero: false,
                nombre_mesero: localStorage.getItem('nombre_mesero'),
                pinInput: '',
                id_company: localStorage.getItem('id_company'),
                errorLogin: null,
                active_login_with_code: localStorage.getItem('active_login_with_code'),
                select_waiters: localStorage.getItem('select_waiters'),
                table_list: {
                    mesas_ocupadas: [],
                    mesas: []
                },
                id_point_waiter: ''
            }
        },
        methods: {
          finishTableWaiters($form){
            this.popupActivoModeMesero = false;
            if($form)this.onFinish($form)
            else{
              this.clearInput();
              this.waiter_selector = true;
            }
          },
          appendNumber(number) {
              if (this.pinInput.length < 4) {
                  this.pinInput += number;
              }
          },
          clearInput() {
              this.pinInput = '';
          },
          submitPin() {
              if (this.pinInput.length === 4) {
                  axios.post('/api/company/validate-code2',{  pin: this.pinInput, id_company: this.id_company  })
                  .then(res=>{
                      if(res.data.status==200){
                          if(res.data.user.id_tipo_rol == 160){
                              localStorage.setItem('nombre_mesero', res.data.user.name);
                              localStorage.setItem('id_user_mesero', res.data.user.id);
                              localStorage.setItem('punto', res.data.user.name_point);
                              localStorage.setItem('id_point_waiter', res.data.user.id_point);
                              this.id_point_waiter = res.data.user.id_point;
                              this.waiter_selector = false;
                              this.nombre_mesero = res.data.user.name;
                              this.popupActivoModeMesero = true;
                          }else{
                              this.errorLogin="El usuario no es un mesero.";
                          }
                      } else{
                          this.errorLogin="Pin Inválido."
                      }
                  }).catch(err=>{
                      this.errorLogin="Error al intentar ingresar, por favor intete mas tarde." + err
                      localStorage.setItem('loginStatus', false);
                  });
                  
              }else {
                  this.errorLogin = "El PIN debe tener 4 dígitos";
              }
          },
        },
        mounted() {
            localStorage.removeItem('nombre_mesero');
            localStorage.removeItem('id_user_mesero');
            localStorage.removeItem('punto');
        }
    }
</script>

<style>
    .login-keyboard {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999;
        background: rgba(255, 255, 255, 0.5);
        -webkit-backdrop-filter: blur(10px);
        backdrop-filter: blur(5px);
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .waiter-selector {
        width: 100%;
        max-width: 320px; /* Ancho máximo para mejor legibilidad */
        display: flex;
        justify-content: center;
    }

    .waiter-pin-section {
        border-radius: 20px;
        text-align: center;
        padding: 30px;
        background: white;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
        width: 100%;
    }

    .waiter-pin-input {
        width: 100%;
        max-width: 200px;
        padding: 12px;
        /*font-size: 24px;*/
        text-align: center;
        letter-spacing: 4px;
        border: 2px solid #ddd;
        border-radius: 8px;
        margin-bottom: 20px;
    }

    .pin-keypad {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 10px;
        max-width: 300px;
        margin: 0 auto;
    }

    .pin-key {
        padding: 15px;
        font-size: 20px;
        border: none;
        border-radius: 8px;
        background: #f8f9fa;
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .pin-key:hover {
        background: #e9ecef;
    }

    .pin-key.pin-clear {
        background: #dc3545;
        color: white;
    }

    .pin-key.pin-enter {
        background: #28a745;
        color: white;
    }

    .pin-key.pin-clear:hover {
        background: #c82333;
    }

    .pin-key.pin-enter:hover {
        background: #218838;
    }


    /*POPUP DE MESERO*/

    /* Contenedor principal */
.mesas-popup-custom {
  max-width: 800px;
  width: 90% !important;
  border-radius: 15px;
  overflow: hidden;
}

.popup-mesas-container {
  padding: 20px;
  font-family: 'Poppins', sans-serif;
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: white;
}

/* Encabezado */
.popup-header {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-shrink: 0;
}

.logo-container {
  width: 250px;
  height: 100px;
}

.popup-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.back-button {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: 2px solid #0B9BCF;
  color: #0B9BCF;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.back-button:hover {
  background: #0B9BCF;
  color: white;
}

/* Contenedor con scroll */
.scroll-container {
  overflow-y: auto;
  max-height: 60vh;
  padding-right: 10px;
  flex-grow: 1;
}

/* Personalización de la barra de scroll */
.scroll-container::-webkit-scrollbar {
  width: 8px;
}

.scroll-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.scroll-container::-webkit-scrollbar-thumb {
  background: #0B9BCF;
  border-radius: 10px;
}

.scroll-container::-webkit-scrollbar-thumb:hover {
  background: #098fba;
}

/* Secciones */
.mesas-section {
  margin-bottom: 25px;
}

.section-title {
  text-align: left;
  padding-left: 15px;
  margin-bottom: 15px;
  color: #333;
  font-weight: 400;
}

.section-divider {
  height: 1px;
  background: #e0e0e0;
  margin: 20px 0;
}

/* Grid de mesas */
.mesas-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 15px;
}

/* Tarjetas de mesa */
.mesa-card {
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  overflow: hidden;
  transition: all 0.3s ease;
}

.mesa-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0,0,0,0.15);
}

.mesa-content {
  padding: 5px;
  position: relative;
}

.mesa-info {
  width: 75%;
}

.mesa-action {
  position: absolute;
  top: 0;
  right: 0;
  background: #0B9BCF;
  color: white;
  height: 100%;
  width: 25%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.mesa-action:hover {
  background: #098fba;
}

.mesa-content h3 {
  font-size: 16px;
  margin-bottom: 5px;
  color: #333;
}

.mesa-content h4 {
  font-size: 14px;
  margin-bottom: 5px;
  color: #444;
}

.mesa-content h5 {
  font-size: 12px;
  color: #666;
  margin-bottom: 5px;
}

/* Responsive */
@media (max-width: 768px) {
  .mesas-grid {
    grid-template-columns: 1fr;
  }
  
  .mesa-card {
    max-width: 100%;
  }
  
  .scroll-container {
    max-height: 50vh;
  }
}
</style>
